<div class="page">
    <div class="two-column-layout">
        <div class="left-column">
            <app-device-live-view #liveView
                                  [isBusy]="isBusy"
                                  [entityId]="pbxId"
                                  [installationId]="installationId"
                                  [shadowUpdates]="shadowUpdates"
                                  [entityKind]="CallEntityKind.PBX"
                                  [placeholderUrl]="pbx?.image_url ?? 'assets/images/background.jpeg'">
            </app-device-live-view>
        </div>
        <div class="right-column">
            <app-widget-card
                    icon="assets/icons/ic_user.svg"
                    [title]="'General.Contacts' | i18next"
                    [showAreaPlaceholder]="isBusy"
                    minHeight="500px"
            >
                <div style="height: 565px; overflow-y: auto;">
                    <dx-list
                        id="managedUnitsList"
                        [dataSource]="pbx?.managed_units || []"
                        keyExpr="id"
                        [hoverStateEnabled]="false"
                        [activeStateEnabled]="false"
                        [focusStateEnabled]="false"
                        [searchEnabled]="true"
                        [searchExpr]="['name','location','address','alias']"
                        itemTemplate="unitItem"
                    >
                        <dxo-search-editor-options [placeholder]="'General.SearchContacts' | i18next" />
                        <div *dxTemplate="let unit of 'unitItem'">
                            <div class="unit-list-item"
                                 [attr.data-unit-id]="unit.id"
                                 [class.unit-list-item--disabled]="isEntityOnHold(unit.id, CallEntityKind.Unit)"
                                 [class.unit-list-item--callee]="incomingCalleeId === unit.id">
                                <div class="unit-list-item-icon">
                                    <svg-icon src="assets/icons/ic_home.svg"></svg-icon>
                                </div>
                                <div class="unit-list-item-content">
                                    <div class="unit-list-item-title">{{ unit.name }}</div>
                                    <div class="unit-list-item-description">{{ unit.location || unit.address || unit.alias }}</div>
                                </div>
                                <div class="unit-list-item-icon">
                                    <dx-button
                                        type="success"
                                        [icon]="'assets/icons/ic_phone_call.svg'"
                                        (onClick)="unitCallButtonClick(unit)"
                                        [disabled]="(currentCallingEntity != null && !currentCallOnHold) || isEntityOnHold(unit.id, CallEntityKind.Unit)"
                                    ></dx-button>
                                </div>
                            </div>
                        </div>
                    </dx-list>
                </div>

            </app-widget-card>
        </div>
    </div>

    <div class="two-column-layout">
        <div class="left-column">
            <app-widget-card
                    icon="assets/icons/ic_device.svg"
                    [title]="'General.Devices' | i18next"
                    [showAreaPlaceholder]="isBusy"
                    minHeight="500px"
            >
                <div style="height: 565px; overflow-y: auto">
                    <dx-data-grid [dataSource]="pbx?.devices || []" [hoverStateEnabled]="false" (onRowPrepared)="onDeviceRowPrepared($event)">
                        <dxi-column dataField="name" [caption]="'General.Name' | i18next"></dxi-column>
                        <dxi-column
                                dataField="product_line"
                                [caption]="'General.DeviceLine' | i18next"
                                alignment="left"
                                cellTemplate="productLineTemplate"
                        >
                            <div *dxTemplate="let data of 'productLineTemplate'">
                                {{ data.value | productLineName }}
                            </div>
                        </dxi-column>
                        <dxi-column
                                name="output"
                                dataField="available_outputs"
                                [caption]="'General.Outputs' | i18next"
                                alignment="left"
                                cellTemplate="outputsTemplate"
                        >
                            <div *dxTemplate="let data of 'outputsTemplate'">
                                <ng-container *ngIf="data?.value.length > 0">
                                    <div *ngFor="let output of data.value">
                                        {{ output.name }}
                                    </div>
                                </ng-container>
                            </div>
                        </dxi-column>
                        <dxi-column
                                [caption]="'General.Actions' | i18next"
                                alignment="center"
                                cellTemplate="actions"
                                width="135px"
                        >
                            <div *dxTemplate="let data of 'actions'">
                                <div style="display: flex; align-items: center; gap: 10px;">
                                    <dx-button
                                            *ngIf="!(data.data.status | deviceInStatus: DeviceStatus.Busy)"
                                            class="live-view-button"
                                            [text]="'Dashboard.DeviceLiveView' | i18next"
                                            type="default"
                                            (onClick)="deviceLiveViewButtonClick(data.data)"
                                            [disabled]="!(data.data.status | deviceInStatus: DeviceStatus.Ready) || (currentCallingEntity != null && !currentCallOnHold) || (currentCallOnHold && !(data.data.status | deviceSupportCallv2)) || isEntityOnHold(data.data.id, CallEntityKind.Doorstation)"
                                    ></dx-button>
                                    <dx-button
                                            *ngIf="data.data.status | deviceInStatus: DeviceStatus.Busy"
                                            class="busy-button"
                                            [text]="'Dashboard.BusyDevice' | i18next"
                                            type="default"
                                            [disabled]="true"
                                    ></dx-button>
                                </div>
                            </div>
                        </dxi-column>
                    </dx-data-grid>
                </div>
            </app-widget-card>
        </div>
        <div class="right-column">
            <app-call-events-card [installationId]="installationId" [entityId]="pbxId"
                                  [devices]="pbx?.devices" [units]="pbx?.managed_units ?? []"
                                  [pbxs]="pbx ? [pbx] : []" [eventsProvider]="pbxEventsProvider">
            </app-call-events-card>
        </div>
    </div>
</div>


